
                import "css-modules://src_components_team"
                export default {"Main":"_fd82bd","Inner":"_9026e5","Title":"_de05a8","Grid":"_6369b2","Item":"_d750a4","Name":"_136ead","Image":"_1c9c6d","Aspect":"_28498d","Img":"_f79c45","Description":"_c91ee0","Contact":"_7902b3","Links":"_a73c44"}
            